// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"WizardFNOLAdditionalInformationPage_mainContainer__3PfZq"};